// extracted by mini-css-extract-plugin
export var activeFilterButton = "_q0-c";
export var backButton = "_q0-4";
export var backIcon = "_q0-5";
export var chevronShortcut = "_q0-6";
export var container = "_q0-1";
export var editor = "_q0-8";
export var editorWrapper = "_q0-7";
export var prefix = "_q0-2";
export var searchIcon = "_q0-3";
export var suffix = "_q0-9";
export var suffixContent = "_q0-a";
export var suffixText = "_q0-b";
export var wrapper = "_q0-0";